import React from 'react'; // get the React object from the react module
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import WithDelay from 'helpers/hoc/WithDelay';
import classNames from 'classnames';
import s from './WithCubeAd.scss';
import { showAdCubeFunction, hideCubeAdFunction } from './redux';

class WithCubeAd extends React.Component {
  addEventToCheckCube = () => {
    const adCode = this.getCubeAdCode();
    if (typeof window !== 'undefined') {
      let cubeRenderEventExcuted = false;
      window.googletag = window.googletag || {};
      window.googletag.cmd = window.googletag.cmd || [];
      window.googletag.cmd.push(() => {
        window.googletag.pubads().addEventListener('slotRenderEnded', event => {
          if (
            event &&
            event.slot &&
            typeof event.slot.getAdUnitPath === 'function' &&
            event.slot.getAdUnitPath() === adCode &&
            !cubeRenderEventExcuted
          ) {
            this.props.showAdCubeFunction();
            cubeRenderEventExcuted = true;
          }
        });
      });
    }
  };

  getCubeAdCode() {
    const { siteConfig, isWapView } = this.props;
    let adCode;
    if (
      !(typeof siteConfig === 'object' && typeof siteConfig.cube === 'object')
    ) {
      adCode = null;
    } else {
      adCode = isWapView
        ? siteConfig.cube.adCodes.mweb
        : siteConfig.cube.adCodes.web;
    }
    return adCode;
  }

  render() {
    const adCode = this.getCubeAdCode();
    if (typeof adCode !== 'string') {
      return null;
    }

    const pageName =
      typeof this.props.pageType === 'string'
        ? this.props.pageType.toLowerCase()
        : null;
    return (
      <div
        className={classNames({
          [`${s.toiCube}`]: true,
          [`${s.articleshow}`]: this.props.pageType === 'ARTICLESHOW',
          [`${s[pageName]}`]: pageName,
          [`${s.openInAppVisible}`]: this.props.openInAppBtnVisible,
          [`${s.hidden}`]: this.props.isMobile && this.props.popUpVisble,
          [s.shiftUp]: !this.props.isMobile && this.props.popUpVisble,
        })}
      >
        <WithDelay delay={1500}>
          <AdCaller
            immediateLoad
            className={s.cubeClass}
            data={{
              divId: 'div-gpt-ad-cube-1556564523324-0',
              adCode,
              size: [[1, 1]],
            }}
            deviceType="all"
            callback={() => {
              this.addEventToCheckCube();
            }}
          />
        </WithDelay>
      </div>
    );
  }
}
WithCubeAd.propTypes = {
  isWapView: PropTypes.bool,
  // hideCubeAdFunction: PropTypes.func,
  showAdCubeFunction: PropTypes.func,
  openInAppBtnVisible: PropTypes.bool,
  pageType: PropTypes.string,
  popUpVisble: PropTypes.bool,
  siteConfig: PropTypes.shape({
    cube: PropTypes.shape({
      adCodes: PropTypes.shape({
        web: PropTypes.string,
        mweb: PropTypes.string,
      }),
    }),
  }).isRequired,
  isMobile: PropTypes.bool,
};

WithCubeAd.defaultProps = {
  isWapView: false,
  showAdCubeFunction: undefined,
  openInAppBtnVisible: false,
  pageType: undefined,
  popUpVisble: false,
  isMobile: false,
};

const mapStateToProps = state => ({
  showAdCube: state.showAdCube,
  popUpVisble: state.WithPopup && state.WithPopup.isVisible,
  siteConfig: state.common.siteConfig,
  isMobile: state.isMobile,
});

const mapDispatchToProps = dispatch => ({
  showAdCubeFunction: () => {
    dispatch(showAdCubeFunction());
  },
  hideCubeAdFunction: () => {
    dispatch(hideCubeAdFunction());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WithCubeAd);
